import { ChangeDetectionStrategy, Component, Input, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SettingsComponent {
  private readonly destroyRef = inject(DestroyRef);

  baseUrls: any = {};
  headerData: any = {};
  rowData: any = {};
  filterParams: any = {};
  user: any = {};
  serverConfig: any = {};
  action: 'home' | 'uploadImg' = 'home';
  pageTitle = 'User Settings';
  uploadNotImplementedMessage =
    'Profile image upload flow parity is pending; remove flow is available.';

  constructor(
    private http: HttpClient,
    private gtwSnackbarService: GtwSnackbarService
  ) {}

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      const parsed = typeof baseUrls === 'string' ? safeJsonInput<any>(baseUrls, null, 'settings.parse1') : baseUrls;
      if (parsed && Object.keys(parsed).length > 0) {
        this.baseUrls = parsed;
      }
    } catch (e) {
      console.log('Base URLs input not yet stable.');
    }
  }

  @Input('header-data')
  set _header_data(headerData: string) {
    try {
      const parsed = typeof headerData === 'string' ? safeJsonInput<any>(headerData, null, 'settings.parse2') : headerData;
      if (parsed && Object.keys(parsed).length > 0) {
        this.headerData = parsed;
        this.user = parsed?.userSettingsData?.user ?? {};
        this.serverConfig = parsed?.serverConfigData ?? {};
      }
    } catch (e) {
      console.log('Header data input not yet stable.');
    }
  }

  @Input('row-data')
  set _row_data(rowData: string) {
    try {
      this.rowData = typeof rowData === 'string' ? safeJsonInput<any>(rowData, null, 'settings.parse3') : rowData || {};
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  @Input('filter-params')
  set _filter_params(filterParams: string) {
    try {
      const parsed = typeof filterParams === 'string' ? safeJsonInput<any>(filterParams, null, 'settings.parse4') : filterParams;
      if (parsed && Object.keys(parsed).length > 0) {
        this.filterParams = parsed;
      }
    } catch (e) {
      console.log('Filter params input not yet stable.');
    }
  }

  changeAction(action: 'home' | 'uploadImg'): void {
    this.action = action;
  }

  removeProfileImage(): void {
    const apiBase = this.baseUrls?.api || this.baseUrls?.admin || '';
    if (!apiBase) {
      this.gtwSnackbarService.openSnackBar('Base URL not available.', 'gtw-snackbar--red');
      return;
    }

    this.http
      .post<any>(
        `${apiBase}/removeUserAvatar`,
        { fileKey: 377 },
        { withCredentials: true }
      ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.user = { ...this.user, avatar_path: null };
          this.gtwSnackbarService.openSnackBar('Image Removed!', 'gtw-snackbar--green');
        },
        error: () => {
          this.gtwSnackbarService.openSnackBar(
            'Error occurred fetching data. If this continues please contact support',
            'gtw-snackbar--red'
          );
        },
      });
  }
}
